export default __webpack_public_path__ + "static/kraken-c6edbc19064994a9c92c1e78f80cc259.png";